import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  deleteFastTracks,
  readFastTrackItems,
  readFastTrackPrompts,
  readFlow,
  shareFastTrackWithUsers,
  shareFastTrackWithClientGroup,
  updateFastTrackName,
} from '@api/fast_tracks';

import Delete from '../../components/ListPage/components/ActionsToolbar/components/Delete';
import Details from '../../components/ListPage/components/ActionsToolbar/components/Details';
import ItemAnswers from '../../components/ItemAnswers';
import FlowDownload from '../../components/ListPage/components/ActionsToolbar/components/FlowDownload';
import ListPage from '../../components/ListPage';
import ModalBuildFastTrack from '../../../FastTracks/components/ModalBuildFastTrack';
import Rename from '../../components/ListPage/components/ActionsToolbar/components/Rename';
import Reprompt from '../../components/ListPage/components/ActionsToolbar/components/Reprompt';
import Share from '../../components/ListPage/components/ActionsToolbar/components/Share';

import { FILTER_OPTIONS, ITEM_COLUMNS } from './utilities/helpers';

const FastTracks = () => {
  const navigate = useNavigate();
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fastTrackRoute = useMemo(() => {
    if (!selectedFlow) return {};
    return {
      id: selectedFlow?.fastTrackId,
      name: selectedFlow?.fastTrackName,
      path: `/dashboard/narrative/${selectedFlow?.fastTrackId}`,
    };
  }, [selectedFlow]);

  const handleReprompt = (flow) => {
    setSelectedFlow(flow);
    setIsModalOpen(true);
  };
  return (
    <>
      <ListPage
        filterOptions={FILTER_OPTIONS}
        itemActions={[
          <Details />,
          <Rename
            type="Narrative"
            updateName={({ name, row }) => updateFastTrackName({ id: row.id, name })}
          />,
          <Reprompt handleReprompt={handleReprompt} />,
          <FlowDownload />,
          <Share
            shareWithClient={shareFastTrackWithClientGroup}
            shareWithUsers={shareFastTrackWithUsers}
          />,
          <Delete
            deleteItems={(selectedRows) =>
              deleteFastTracks({ ids: selectedRows.map(({ id }) => id) })
            }
          />,
        ]}
        itemColumns={ITEM_COLUMNS}
        onCreate={() => navigate('/dashboard/narratives')}
        readItems={readFastTrackItems}
        renderRowExpanded={({ row }) => (
          <ItemAnswers
            item={row?.original}
            readItemAnswers={readFlow}
            readPrompts={readFastTrackPrompts}
            type="Flow"
          />
        )}
        type="Narrative"
        workspace="FastTracks"
      />
      {isModalOpen && (
        <ModalBuildFastTrack
          flowId={selectedFlow?.id}
          route={fastTrackRoute}
          setIsModalOpen={(value) => {
            setSelectedFlow(null);
            setIsModalOpen(value);
          }}
        />
      )}
    </>
  );
};

export default FastTracks;
